import styled from "styled-components";
import { colors } from "../contants";

export const TitleWrapper = styled.div`
  max-width: 1120px;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 0 1.5rem;

  h1 {
    font-size: clamp(1.6rem, 3vw, 2.2rem);
    color: #1a1a22;
    position: relative;
    padding-bottom: 1rem;
    margin-bottom: 0;

    &::after {
      content: "";
      position: absolute;
      left: 50%;
      bottom: 0;
      transform: translateX(-50%);
      width: 56px;
      height: 3px;
      background: ${colors.gold};
      border-radius: 2px;
    }
  }
`;

export const Gallery = styled.div`
  padding: clamp(4rem, 8vw, 5.5rem) 0;
  background-color: #ffffff;
`;

export const GalleryWrapper = styled.div`
  margin-top: 3rem;
  align-items: center;
  justify-content: center;
  max-width: 1120px;
  width: 100%;
  margin-left: auto;
  margin-right: auto;
  border-radius: 12px;
  overflow: hidden;
  border: 1px solid rgba(40, 40, 50, 0.12);
  box-shadow: 0 10px 30px rgba(20, 20, 40, 0.1);
`;

export const Title = styled.h3`
  font-size: 2rem;
`;

export const GalleryText = styled.h3`
  color: black;
  font-size: 1.8rem;
`;
